var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.389,
    height: 8.582,
    viewBox: "0 0 12.389 8.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-email-5279456",
    transform: "translate(-105.001 -105.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M129.433,108.917l5.535-3.693a1.468,1.468,0,0,0-.8-.221H124.2a1.491,1.491,0,0,0-.831.243l5.58,3.679a.474.474,0,0,0,.244.062.469.469,0,0,0,.241-.069Z",
    transform: "translate(-17.987 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M106.284,153.344h9.822a1.29,1.29,0,0,0,.907-.372,1.264,1.264,0,0,0,.376-.9v-6.218a1.174,1.174,0,0,0-.027-.254l-5.371,4.4a1.31,1.31,0,0,1-1.58.013l-5.393-4.37a1.093,1.093,0,0,0-.018.21v6.218a1.264,1.264,0,0,0,.376.9,1.29,1.29,0,0,0,.907.372Z",
    transform: "translate(0 -39.759)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.244d0d1144f288bd0af24acbcd62657f.svg";
export { ForwardRef as ReactComponent };